/**
 * Sizzle reel shown on the homepage hero. Clips play in this order.
 * `startAt` is in seconds (where the clip begins), `duration` in milliseconds.
 */
export const reel = {
  videos: [
    {
      src: 'https://www.dropbox.com/scl/fo/vqn0t65vsxkr7px0fcbym/ALJz8Y0vuRpQU96Vnz-ntTU/Videos/2026-4-17%20Cadet%20Pop%20Up%20Dallas%20Video%2016x9.mp4?rlkey=tqubewmw6ntro8zxd776hr2jd&raw=1',
      startAt: 2.0,
      duration: 5500,
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/t5YhuyspZCwML6wRN4gmD4/30_sec_v2-2_15MB.mp4',
      startAt: 2.0,
      duration: 5500,
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/kmjdqLDZB9qse24STmXhWi/GlowVolution_VENUE_15MB.mp4',
      startAt: 5.5, // Skips the intro logos
      duration: 5500,
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/5aoxKQ2w5tY24PbsmziDvv/SnapInsta.to_AQM5TMjyjLSS6yxVX7aYL43PmRWTeZT-1JmzD1ugCRWT9sJiMRJRX1EMyr7r3eYuFuI-lRdGfwhvRs5lOVeKH6sME8lMmeAyKj_3Jz8.mp4',
      startAt: 0, // Adidas All Star
      duration: 5500,
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/mL2ewvfEwvTv51KKsFMKkp/TonyMoly%20Video.mp4',
      startAt: 7.5, // Skips the love letter, jumps to crowd interactions
      duration: 5500,
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/wKVcyNrGNJ76mjrQAKpHVJ/SnapInsta.to_AQMYDfY2DIVwyZf6QvIIN_GRqBGURWEx3WF1_dI2hwuUEnfgW1hFGpqCfMnQgxQY_3wZyvGMOtucCcumjVp5dNN4AEBMLhrCagz13xc.mp4',
      startAt: 1.0,
      duration: 5500,
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/r8TgN2EzStB9XYdvMSDaEJ/Western%20Sons%20Video.mp4',
      startAt: 0,
      duration: 5500,
    },
  ],
  poster:
    'https://cdn.magicpatterns.com/uploads/aFMzauK4UNHrDf4DggPR7i/WizardWellness-CoachellaActivation-KathyDeNinnoPhotography-53.jpg',
  caption: 'Breezy 2026 Sizzle Reel',
}
